import { useState, useEffect } from "react";
import { CheckCircle, Loader, AlertTriangle, ClipboardList, User } from "lucide-react";
const Boxcard = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);
  const [dueTasks, setDueTasks] = useState(0);
  const [todaysTasks, setTodaysTasks] = useState(0);
  const [completedTasksList, setCompletedTasksList] = useState(0);

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      const today = new Date().toISOString().split("T")[0];
      const summary = result.summary;
      const allTasks = result.tasks || [];
      const allUsers = result.users || [];
      const totalTasksCount = summary.total_unique_tasks;
      const totalUsersCount = summary.total_users;

      const todaysTasksList = summary.today_tasks;

      const dueTasksList = summary.pending_tasks;
      const completedTasksList = summary.completed_tasks;

      setCompletedTasksList(completedTasksList);
      setTotalTasks(totalTasksCount);
      setTotalUsers(totalUsersCount);
      setTodaysTasks(todaysTasksList);
      setDueTasks(dueTasksList);
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
  };

  return (
    <div className="Dashboard-1">
      <ul>
        <li className="flex flex-col justify-between rounded-xl shadow-md p-4 bg-white hover:shadow-lg transition-shadow duration-300  "
            >
          <div>
            
            <User className="text-gray-700 w-6 h-6" />
            <div>
              <h3>Total Users</h3>
              <p>{totalUsers}</p>
            </div>
          </div>
        </li>
        <li className="flex flex-col justify-between rounded-xl shadow-md p-4 bg-white hover:shadow-lg transition-shadow duration-300  "
            >
          <div>
            <ClipboardList className="text-purple-600 w-6 h-6" />
            <div>
              <h3>Total Tasks</h3>
              <p>{totalTasks}</p>
            </div>
          </div>
        </li>
        <li className="flex flex-col justify-between rounded-xl shadow-md p-4 bg-white hover:shadow-lg transition-shadow duration-300  "
            >
          <div>
            <AlertTriangle className="text-yellow-600 w-6 h-6" />
            <div>
              <h3>Delayed Tasks</h3>
              <p>{dueTasks}</p>
            </div>
          </div>
        </li>
        <li className="flex flex-col justify-between rounded-xl shadow-md p-4 bg-white hover:shadow-lg transition-shadow duration-300  "
            >
          <div>
            <Loader className="text-blue-600 w-6 h-6 " />
            
            <div>
              <h3>Today's Tasks</h3>
              <p>{todaysTasks}</p>
            </div>
          </div>
        </li>
        <li className="flex flex-col justify-between rounded-xl shadow-md p-4 bg-white hover:shadow-lg transition-shadow duration-300  "
              >
          <div>
            {/* <img
              src="https://cdn-icons-png.flaticon.com/512/991/991946.png"
              alt="Today's Tasks"
            /> */}
            <CheckCircle className="text-green-600 w-6 h-6" />
            <div>
              <h3>Completed Tasks</h3>
              <p>{completedTasksList}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Boxcard;

const formatDateOnly = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
